// extracted by mini-css-extract-plugin
export default {"searchResults":"bx_gF","resultsMessage":"bx_gG","breadcrumb":"bx_gH","isOpen":"bx_fC","hitCount":"bx_gJ","hasResults":"bx_gK"};